var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"box-container"},[_c('div',{staticClass:"center-box"},[_c('img',{staticClass:"box-logo",attrs:{"id":"boxLogo"}}),_c('p',{staticClass:"main-text"}),_c('button',{staticClass:"continue-btn"})]),_c('div',{staticClass:"bottom-box"})])])
}]

export { render, staticRenderFns }